export interface ImageDimension {
  width: number;
  height: number;
}
